<template lang="html">
    <div class="layout--main" >


    <template >
      
    </template>
    <!-- /Navbar -->

      <div class=" perfil-margin">

        <div class="router-view">
          <div class="router-content">

              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
                <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />

                <!-- DROPDOWN -->
                <vs-dropdown vs-trigger-click class="ml-auto md:block hidden cursor-pointer">
                  <vs-button radius icon="icon-settings" icon-pack="feather" />

                  <vs-dropdown-menu class="w-32">
                    <vs-dropdown-item>
                      <div @click="$router.push('/pages/profile').catch(() => {})" class="flex items-center">
                        <feather-icon icon="UserIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Profile</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div @click="$router.push('/apps/todo').catch(() => {})" class="flex items-center">
                        <feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Tasks</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div @click="$router.push('/apps/email').catch(() => {})" class="flex items-center">
                        <feather-icon icon="MailIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Inbox</span>
                      </div>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>

                </vs-dropdown>

              </div>

            <div class="">
<vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">
    <vs-tab icon-pack="feather" icon="icon-settings" :label="!isSmallerScreen ? 'General' : ''">
      <Generales/>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-file-text" :label="!isSmallerScreen ? 'Reportes de crédito' : ''">
      <Reportes/>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-image" :label="!isSmallerScreen ? 'Widget' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <vx-card title="Widget" class="">
          <Widget/>
        </vx-card>
      </div>
    </vs-tab>
  </vs-tabs>
            </div>
          </div>
        </div>
      </div>
<div class="footer">COPYRIGHT 2021 Cotizador SOC, todos los derechos reservados.</div>    </div>
  </div>
  
</template>
<script>
import TheNavbarVerticalInmobiliaria   from '@/layouts/components/navbar/TheNavbarVerticalInmobiliaria.vue'
import Generales from '@/views/Perfil/Generales.vue'
import Reportes from '@/views/Perfil/Reportes.vue'
import GraficasSoc from '@/views/Perfil/GraficasSoc.vue'
import Widget from '@/views/Perfil/Widget.vue'
export default {
  components: {
    TheNavbarVerticalInmobiliaria,
    Generales,
    Reportes,
    GraficasSoc,
    Widget
  },
  data(){
    return{
    isSoc:false,
    tieneActivoBuro:false
    }
  },
  mounted(){
    if (this.$store.state.AppActiveUser.WidgetColorPrimario != '') {
      this.$vs.theme({
        primary:this.$store.state.AppActiveUser.WidgetColorPrimario
      })
    }
    if(this.$store.state.AppActiveUser.TipoEjecutivoV3=='SOC'){
      this.isSoc=true
    }
    this.tieneActivoBuro = this.$store.state.AppActiveUser.BuroCredito
    
  },
  computed: {
    isSmallerScreen () {
      return window.screen.width < 768
    }
  }
}
</script>

<style lang="css" scoped>
.perfil-margin{
  padding-top: 80px;
}
.table-custom{
  margin-top: -5%;
}
iframe{
  border: none;
}
.selectExample {
  width: 30%;
}
@media screen and (max-width:869px) {
  .footer{
    background: #FFF;
    padding-top: 30px;
    margin-top: 0;
    margin-bottom: 0;
  }
  
}
@media only screen and (max-width: 600px) {
  .selectExample{
    margin-top: 4%;
  }
}
</style>
